export default __webpack_public_path__ + "/dist/images/action.93b181ba408f94114639077e5c1916c6.svg";